export const getRGBColor = (hex: string, type: string) => {
    let color = hex.replace(/#/g, "")
    var r = parseInt(color.substr(0, 2), 16)
    var g = parseInt(color.substr(2, 2), 16)
    var b = parseInt(color.substr(4, 2), 16)
    return `--emf-color-${type}: ${r}, ${g}, ${b};`
}

export const getAccessibleColor = (hex: string) => {
    let color = hex.replace(/#/g, "")
    // rgb values
    var r = parseInt(color.substr(0, 2), 16)
    var g = parseInt(color.substr(2, 2), 16)
    var b = parseInt(color.substr(4, 2), 16)
    var yiq = (r * 299 + g * 587 + b * 114) / 1000
    return yiq >= 148 ? "#000000" : "#FFFFFF" //128 => 148
}

export const getThemeStyle = (className: string, color: string | undefined) => {
    if (!color) {
        color = defaultPrimaryColor;
    }
    const primaryColor = getRGBColor(color, "primary")
    const secondaryColor = getRGBColor(getAccessibleColor(color), "secondary")
    const themeStyles = `.${className} {${primaryColor} ${secondaryColor}}`;
    return themeStyles;
}

export const defaultPrimaryColor = "#a38300";

export const getUniqueThemeClass = (append: string = '') => append + "-emf-theme-" + Math.random().toString(16).slice(2);

export const generateUniqueId = (append: string = '') => (append ? append + '-' : '') + Math.random().toString(16).slice(2);

export const getAppliedPrimaryColor = (theme: string | undefined) => { return theme || defaultPrimaryColor }

export default { getRGBColor, getAccessibleColor, getThemeStyle, getUniqueThemeClass, getUniqueId: generateUniqueId }

export function groupBy<T>(data : T[], f: { (k: any): any; (arg0: T): any }) {
  return data.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
}